import client from './client';
import type { AuditLogEntry } from '@/types/api';

export interface AuditLogPage {
  content: AuditLogEntry[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const auditApi = {
  getAll: async (params?: {
    page?: number;
    size?: number;
    actionType?: string;
    entityType?: string;
    search?: string;
  }): Promise<AuditLogPage | AuditLogEntry[]> => {
    const res = await client.get('/audit-logs', { params });
    return res.data;
  },

  getByEntity: async (entityType: string, entityId: string): Promise<AuditLogEntry[]> => {
    const res = await client.get<AuditLogEntry[]>(`/audit-logs/entity/${entityType}/${entityId}`);
    return res.data;
  },

  getByLocation: async (locationId: string): Promise<AuditLogEntry[]> => {
    const res = await client.get<AuditLogEntry[]>(`/audit-logs/location/${locationId}`);
    return res.data;
  },
};
